<template>
  <div class="d-flex justify-start mt-5 mb-3">
    <h2>{{ title }}</h2>
  </div>
</template>

<script>
export default {
  props: [
    'title'
  ]
}
</script>
